import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { RemoveorganisationService } from './removeorganisation.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-removeorganisation',
  templateUrl: './removeorganisation.component.html',
  styleUrls: ['./removeorganisation.component.css']
})
export class RemoveorganisationComponent {

  @ViewChild('swap') inputField: ElementRef;
  orgList: any = {};
  tableData: any = {};
  lawcategoryList: any = {};
  luScrollHeight = '';
  CSRFToken = "";
  cols = [];
  attctr: any = 0;
  ref: DynamicDialogRef | undefined;
  orgid: any;
  tablename: any;
  attachcount: number = 0;
  items: MenuItem[] | undefined;
  selectedItem: MenuItem | null = null;
  idArray: any[];

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private utilityserv: Utilityservice,
    private removeservice: RemoveorganisationService,
    public dialogService: DialogService,
    public helpservice: PagehelpmodalService,
  ) {
    this.gettoken();

  }

  ngOnInit() {
    this.getdropdowndata();
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])


  getdropdowndata() {
    this.removeservice.getorganisations().subscribe((data: any) => {
      this.orgList = data;
    })
  }

  gettabledata(event: any) {
    this.orgid = event.value;
    this.spinner.hide();
    if (!this.orgid) { Swal.fire({ title: 'Please select an Organisation.', icon: 'warning' }); return; }
    this.removeservice.getorgattachmentnumbers(this.orgid).subscribe((data) => {
      this.attachcount = data[0].ctr;
      this.spinner.hide();
    }
      , error => {
        this.spinner.hide();
        Swal.fire({ icon: "error", title: "Oops...", text: error.error.error, footer: "error status is :" + ' ' + error.status });
      });

    this.removeservice.getlistoftables(this.orgid).subscribe((data) => {
      this.tableData = data;
      this.spinner.hide();
    }
      , error => {
        this.spinner.hide();
        Swal.fire({ icon: "error", title: "Oops...", text: error.error.error, footer: "error status is :" + ' ' + error.status });
      });


  }

  gettoken() {
    this.CSRFToken = '';
    this.removeservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })

  }



  removeorganisation() {
    if (!this.orgid) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Please Select an Organisation..' }); return;
    }

    Swal.fire({
      title: "Are you sure you want to DELETE the selected Organisation?",
      showCancelButton: true, confirmButtonText: "Yes, I am Sure!", icon: "warning"
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          tabledata: this.tableData,
          orgid: this.orgid,
          csrftoken: this.CSRFToken
        }
        this.spinner.show();
        this.removeservice.removeOrganisation(payload).subscribe(() => {
          this.spinner.hide();
          Swal.fire("Organisation Data permanently deleted!", "", "success").then(() => {
            window.location.reload();
          });
        }, error => {
          this.spinner.hide();
          Swal.fire(error.error.message, '', 'error');
        });
      } else if (result.isDenied) {
        Swal.fire("Organisation Data not deleted", "", "info")
      }
    });


  }

}
